import React from "react";
import { annualFiltersObj } from "hooks/useOrderFilters/useDropFilters";
import DropFilter from "components/dropdown/DropFilter";
import { DropFilterCheckboxOptionals } from "components/dropdown/dropFilterTypes";
import { useTranslation } from "react-i18next";
type MonthDropFilterProps = DropFilterCheckboxOptionals & {
  /** When 'Apply' is clicked, returns all ID's of selected facilities */
  handleApply: (year: number | null) => void;

  monthIdValue: "string" | "index";
};

export default function MonthDropFilter(props: MonthDropFilterProps) {
  const monthFilters = annualFiltersObj().monthFilters(props.monthIdValue === "string" ? "value" : "index");
  const { t, i18n } = useTranslation();
  return (
    <DropFilter
      key="month"
      title={t("Month")}
      filterData={monthFilters}
      filterLabelPropFromData="label"
      filterIdPropFromData="id"
      filterType="Checkbox"
      applyFilters={filterReturn => props.handleApply(filterReturn.length === 0 ? null : filterReturn[0].id)}
      defaultCheckboxes={props.defaultCheckboxes}
      leftAligned={props.leftAligned ?? false}
      rightAligned={props.rightAligned ?? false}
      dropdownSize={props.dropdownSize}
      darkMode={props.darkMode}
      save={props.save}
      historyKey={props.historyKey}
      disableDropdown={props.disableDropdown}
      restrain
    />
  );
}
